import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { ListPage } from "../../components/ListPage";
import { DocumentStatusTag } from "../../components/DocumentStatusTag";
import { SiteLabel } from "../../components/SiteLabel";
import { hasAnyGrant } from "../../helpers/permissions";
import { useUser } from "../../context/UserContext";
import type { SiteReturn } from "../../api-models";

export default function ReturnsListPage() {
  const { user } = useUser();
  const navigate = useNavigate();
  const canWrite = hasAnyGrant(user, "Returns.Write");

  return (
    <ListPage<SiteReturn>
      title="Site Returns"
      endpoint="/site-returns"
      searchPlaceholder="Search doc no or reason..."
      linkTo={(r) => `/returns/${r.id}`}
      actions={
        canWrite && (
          <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate("/returns/new")} data-tour="returns-new">
            New return
          </Button>
        )
      }
      columns={[
        { title: "Doc No", dataIndex: "docNo", sorter: true },
        { title: "Site", render: (_, r) => <SiteLabel site={r.site} /> },
        { title: "Reason", dataIndex: "reason", sorter: true, ellipsis: true },
        { title: "Status", dataIndex: "status", sorter: true, render: (v) => <DocumentStatusTag status={v} /> },
      ]}
      renderCard={(r) => (
        <div>
          <strong>{r.docNo}</strong>
          <div><SiteLabel site={r.site} /></div>
          <DocumentStatusTag status={r.status} />
        </div>
      )}
    />
  );
}
